import { MagApiClient } from "./be-api";
import { feEndpoints } from "./fe-api";
import { MagEventChannel } from "./sse-listener";
import * as types from "./types";
import * as packed from "./packed";
import * as endpoints from "./endpoints";
export const notificationTypes = [
    "Follow",
    "FollowRequestReceived",
    "FollowRequestAccepted",
    "Mention",
    "Reply",
    "Renote",
    "Reaction",
    "Quote",
    "PollEnd",
    "App"
];
export { MagApiClient, feEndpoints, MagEventChannel, types, packed, endpoints };
//# sourceMappingURL=index.js.map